function initBuildSubscription() {
  console.log("Build Subscription script loaded ✅");

  const buildBtn = document.getElementById('build-subscription-btn');
  const qtyButtons = document.querySelectorAll('.qty-btn');

  if (!buildBtn) {
    console.warn("Build button not found — probably not on this page.");
    return;
  }

  // Handle plus/minus buttons
  qtyButtons.forEach(btn => {
    btn.addEventListener('click', () => {
      const input = document.getElementById(btn.dataset.target);
      if (!input) return;
      let current = parseInt(input.value);
      if (btn.classList.contains('plus')) input.value = current + 1;
      else if (btn.classList.contains('minus') && current > 0) input.value = current - 1;
    });
  });

  // 🧩 Prefill logic when editing subscription
  const urlParams = new URLSearchParams(window.location.search);
  const recipeParam = urlParams.get('recipes');
  const frequencyParam = urlParams.get('frequency');
  const editingBundleId = urlParams.get('bundle_id');

  if (recipeParam) {
    if (recipeParam.includes('Beef')) {
      const match = recipeParam.match(/Beef Recipe x(\d+)/);
      if (match) document.getElementById('qty-beef').value = match[1];
    }
    if (recipeParam.includes('Turkey')) {
      const match = recipeParam.match(/Turkey Recipe x(\d+)/);
      if (match) document.getElementById('qty-turkey').value = match[1];
    }
  }

  if (frequencyParam) {
    const freqRadio = Array.from(document.querySelectorAll('input[name="frequency"]'))
      .find(r => frequencyParam.includes(r.value));
    if (freqRadio) freqRadio.checked = true;
  }

  // Handle Build Subscription click
  buildBtn.addEventListener('click', async () => {
    console.log("Build Subscription clicked");

    const beefQty = parseInt(document.getElementById('qty-beef')?.value || 0);
    const turkeyQty = parseInt(document.getElementById('qty-turkey')?.value || 0);
    const frequency = document.querySelector('input[name="frequency"]:checked');
    const totalQty = beefQty + turkeyQty;

    if (totalQty < 2) {
      alert(`Please select at least 2 items (currently ${totalQty}).`);
      return;
    }   


    // 🧮 Prices
    const beefPrice = 12.00;
    const turkeyPrice = 12.00;
    const totalValue = (beefQty * beefPrice + turkeyQty * turkeyPrice).toFixed(2);

    const subscriptionItems = [];
    if (beefQty > 0) subscriptionItems.push({ title: 'Beef Recipe', quantity: beefQty });
    if (turkeyQty > 0) subscriptionItems.push({ title: 'Turkey Recipe', quantity: turkeyQty });

   // ✅ Correct version
  const planIds = {
    'Bi-monthly subscription': 3084615815,  // every 2 weeks
    'Monthly subscription': 3084648583      // every 1 month
  };
  const selectedPlanId = planIds[frequency?.value || 'Bi-monthly subscription'];

  // Product IDs (unchanged)
  const beefVariantId = 42258299551879;
  const turkeyVariantId = 42258300272775;
  const dummySubscriptionVariantId = 43357593272455;


    const bundleId = editingBundleId || `custom-subscription-${Date.now()}`;
    const itemsToAdd = [];

    // Hidden recipe items
    if (beefQty > 0) {
      itemsToAdd.push({
        id: beefVariantId,
        quantity: beefQty,
        selling_plan: selectedPlanId,
        properties: {
          bundle_id: bundleId,
          Recipe: "Beef",
          "Part of Subscription": "true"
        }
      });
    }

    if (turkeyQty > 0) {
      itemsToAdd.push({
        id: turkeyVariantId,
        quantity: turkeyQty,
        selling_plan: selectedPlanId,
        properties: {
          bundle_id: bundleId,
          Recipe: "Turkey",
          "Part of Subscription": "true"
        }
      });
    }

    // Parent visible summary item
    itemsToAdd.push({
      id: dummySubscriptionVariantId,
      quantity: 1,
      properties: {
        bundle_id: bundleId,
        selling_plan: selectedPlanId,
        DisplayOnly: "true",
        "Selected Recipes": subscriptionItems.map(i => `${i.title} x${i.quantity}`).join(', '),
        "Delivery Frequency": frequency?.value || 'Bi-monthly subscription',
        "Total Value": `$${totalValue}`
      }
    });

    // 🧹 Remove old bundle if editing
    if (editingBundleId) {
      console.log(`Removing old bundle: ${editingBundleId}`);
      const currentCart = await fetch('/cart.js').then(r => r.json());
      const bundleItems = currentCart.items.filter(i => i.properties?.bundle_id === editingBundleId);

      for (const oldItem of bundleItems) {
        await fetch('/cart/change.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ id: oldItem.key, quantity: 0 })
        });
      }
    }
    
    console.log('Selected frequency value:', frequency?.value);
    console.log('Using selling_plan:', selectedPlanId);


    // 🛒 Add new bundle (with better error handling)
    console.log("Adding updated subscription payload:", itemsToAdd);

    const res = await fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: itemsToAdd }),
      credentials: 'same-origin'
    });

    if (!res.ok) {
      let msg = `Add to cart failed (${res.status})`;
      try {
        const text = await res.text(); // Shopify often returns JSON or plain text
        msg = JSON.parse(text).description || msg; // show useful message if present
        console.error('add.js error:', text);
      } catch (_) {}
      alert(msg);
      return; // <-- do not redirect
    }

    window.location.href = '/cart';

  });
}

document.addEventListener('DOMContentLoaded', initBuildSubscription);
document.addEventListener('shopify:section:load', initBuildSubscription);
document.addEventListener('shopify:section:select', initBuildSubscription);

/* --- Enforce MIN 2 items across recipes (UX helper) --- */
(function () {
  const MIN_QTY = 2;
  const BTN = document.getElementById('build-subscription-btn');
  if (!BTN) return;

  const QTY_SEL = 'input[id^="qty-"]';

  let note = document.getElementById('min-qty-helper');
  if (!note) {
    note = document.createElement('p');
    note.id = 'min-qty-helper';
    note.style.marginTop = '10px';
    note.style.color = '#c0392b';
    note.style.fontWeight = '600';
    note.style.display = 'none';
    BTN.insertAdjacentElement('afterend', note);
  }

  const getInputs = () => Array.from(document.querySelectorAll(QTY_SEL));
  const getTotal = () =>
    getInputs().reduce((sum, el) => sum + (parseInt(el.value, 10) || 0), 0);

  function updateState() {
    const total = getTotal();
    const notEnough = total < MIN_QTY;
    BTN.toggleAttribute('disabled', notEnough);
    BTN.setAttribute('aria-disabled', String(notEnough));
    if (notEnough) {
      note.textContent = `Please select at least ${MIN_QTY} items to continue (currently ${total}).`;
      note.style.display = '';
    } else {
      note.textContent = '';
      note.style.display = 'none';
    }
  }

  document.addEventListener('input', (e) => {
    if (e.target.matches(QTY_SEL)) updateState();
  });

  document.addEventListener('click', (e) => {
    if (e.target.closest('.qty-btn')) setTimeout(updateState, 0);
  });

  const observer = new MutationObserver(updateState);
  const hookObservers = () => getInputs().forEach(el =>
    observer.observe(el, { attributes: true, attributeFilter: ['value'] })
  );

  window.addEventListener('DOMContentLoaded', () => {
    hookObservers();
    setTimeout(updateState, 0);
  });
  window.addEventListener('load', updateState);

  BTN.addEventListener('click', (e) => {
    const total = getTotal();
    if (total < MIN_QTY) {
      e.preventDefault();
      e.stopPropagation();
      note.textContent = `Add ${MIN_QTY - total} more item${MIN_QTY - total === 1 ? '' : 's'} to continue.`;
      note.style.display = '';
      BTN.classList.add('shake');
      setTimeout(() => BTN.classList.remove('shake'), 400);
      return false;
    }
  });
})();

